import React from 'react';
import clsx from 'clsx';
import { MdCloudOff, MdSearchOff, MdTableChart, MdRefresh } from 'react-icons/md';
import Button from '@srm/ui/button';

interface IProps {
    kind: 'empty' | 'positions' | 'search' | 'error';
    description?: string;
    error?: string;
    compact?: boolean;
    onAction: () => void;
}

const COPY = {
    empty: {
        title: 'Ожидаем предложения участников',
        description: 'После подачи предложений здесь появятся цены, ответы по ТЗ и выбор поставщиков',
        action: 'Обновить',
    },
    positions: {
        title: 'Нет позиций для сравнения',
        description: 'Проверьте состав лотов в закупке. После добавления позиций обновите матрицу',
        action: 'Обновить',
    },
    search: {
        title: 'Лоты и позиции не найдены',
        description: 'Попробуйте другое название или сбросьте поиск, чтобы увидеть все позиции',
        action: 'Сбросить поиск',
    },
    error: {
        title: 'Не удалось загрузить предложения',
        description: 'Повторите загрузку. Если ошибка повторится, обратитесь к администратору',
        action: 'Повторить загрузку',
    },
};

const MatrixState: React.FC<IProps> = ({ kind, description, error, compact, onAction }) => {
    const copy = COPY[kind];
    const Icon = kind === 'error' ? MdCloudOff : kind === 'search' ? MdSearchOff : MdTableChart;
    return (
        <div
            className={clsx('ws2-state', `ws2-state--${kind}`, compact && 'ws2-state--compact')}
            role={kind === 'error' ? 'alert' : 'status'}
        >
            <Icon className="ws2-state__icon" size="36px" aria-hidden />
            <div className="ws2-state__content">
                <h3>{compact ? 'Не удалось обновить предложения' : copy.title}</h3>
                <p>{description || copy.description}</p>
                {error && (
                    <details className="ws2-state__details">
                        <summary>Подробности ошибки</summary>
                        <p>{error}</p>
                    </details>
                )}
            </div>
            <Button
                variant={kind === 'error' ? 'primary' : 'outline-neutral'}
                size="sm"
                startAdornment={kind !== 'search' ? <MdRefresh size="18px" aria-hidden /> : undefined}
                onClick={onAction}
            >
                {copy.action}
            </Button>
        </div>
    );
};

export default MatrixState;
